export const termsConstants = {
  LOAD_REQUEST: 'TERMS_LOAD_REQUEST',
  LOAD_SUCCESS: 'TERMS_LOAD_SUCCESS',
  LOAD_FAILURE: 'TERMS_LOAD_FAILURE',
}
